import { useSelector } from 'react-redux';
import StyledDiv from 'components/styled/StyledDiv';
import {
  DEFAULT_PRIMARY_COLOUR,
  DEFAULT_SECONDARY_COLOUR,
  DEFAULT_SECONDARY_COLOUR_LIGHT,
} from 'shared/constants/styleConstants';

export default function MessageQuoteConsultant({ messageAgentClicked }) {
  const { theme } = useSelector((state) => state.ui);

  const customStyles = `
    border-radius: 0.5rem;
    background-image:
    radial-gradient(circle at 20% top, ${
      theme.brandColour || DEFAULT_SECONDARY_COLOUR
    } 0%, ${theme.brandColour || DEFAULT_SECONDARY_COLOUR} 78%, ${
    theme.primaryColour || DEFAULT_SECONDARY_COLOUR_LIGHT
  } 65%, ${theme.primaryColour || DEFAULT_SECONDARY_COLOUR_LIGHT} 100%);
    margin-top: 20px;
    max-width: 330px;
    height: 100%;

    @media (min-width: 768px) {
      margin-top: 0;
    }

    @media (min-width: 1024px) {
        margin-top: 20px;
      div.agent-container {
        width: 18rem;
      }
    }
  `;

  const buttonClass = `h-[50px] text-[14px] text-white text-center text-sm rounded-3xl px-8 py-2 cursor-pointer font-medium flex justify-center items-center [@media(hover:hover){&:hover}]:underline`;

  const message = `Get in touch if you'd like something added to your quote.`;
  return (
    <StyledDiv customStyles={customStyles}>
      <div className="text-white px-4 py-5 h-full md:flex md:flex-col md:justify-around">
        <p className="font-medium text-[24px] mb-2">
          Message your Travel Expert
        </p>
        <p className="text-sm">{message}</p>
        <div className="mt-4 flex items-center">
          <a
            className={buttonClass}
            href="#contactAgent"
            onClick={messageAgentClicked}
            style={{
              background: theme.secondaryColour || DEFAULT_PRIMARY_COLOUR,
            }}
          >
            Message Customer Services
          </a>
        </div>
      </div>
    </StyledDiv>
  );
}
